module.exports = __webpack_public_path__ + "img/20210616.76caec3a.gif";